import { Component, Input, forwardRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormsModule } from '@angular/forms';

// PrimeNG
import { CheckboxModule } from 'primeng/checkbox';

@Component({
  selector: 'app-custom-single-choice',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    CheckboxModule,
  ],
  templateUrl: './custom-single-choice.component.html',
  styleUrls: ['./custom-single-choice.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => CustomSingleChoiceComponent),
      multi: true,
    },
  ],
})
export class CustomSingleChoiceComponent implements ControlValueAccessor {
  @Input({ required: true }) options!: { label: string; value: string }[];
  @Input() disabled: boolean = false;
  @Input() layout: string = 'horizontal';
  @Input() fieldKey!: string;
  @Input() index: number | null = null;

  // Internal selected value
  selectedValue: string | null = null;

  private onChangeFn: (value: any) => void = () => {};
  private onTouchedFn: () => void = () => {};

  // ControlValueAccessor methods
  writeValue(value: string | null): void {
    this.selectedValue = value;
  }

  registerOnChange(fn: any): void {
    this.onChangeFn = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouchedFn = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  // Handle checkbox change
  onCheckboxChange(optionValue: string, checked: boolean): void {
    if (this.disabled) return;

    if (checked) {
      this.selectedValue = optionValue;
    } else {
      this.selectedValue = null;
    }

    this.onChangeFn(this.selectedValue);
    this.onTouchedFn();
  }

  // Check if an option is selected
  isSelected(optionValue: string): boolean {
    return this.selectedValue === optionValue;
  }

  getFieldLayoutClass(): string {
    return this.layout === 'vertical' ? 'field-checkbox-group-vertical' : '';
  }

  getInputId(optionValue: string): string {
    const indexPart = this.index !== null ? `_${this.index}` : '';
    return `${this.fieldKey}${indexPart}_${optionValue}`;
  }

  trackByOptionValue(index: number, item: any): any {
    return item.value;
  }
}
